export default __webpack_public_path__ + "static/media/Bitstop_Web_Background.d8e580e9.svg";